export enum DeedDocumentType { // manualy sorted, order of items will be reflected in UI
  limited_warranty_deed = 'limited_warranty_deed',
  quitclaim_deed = 'quitclaim_deed',
  special_warranty_deed = 'special_warranty_deed',
  warranty_deed = 'warranty_deed',
  other = 'other',
}
